export function usePriceFormatterNoFraction(currencyCode: string, locale: string) {
    return new Intl.NumberFormat(locale, {
        style: 'currency',
        currency: currencyCode || 'EUR',
        maximumFractionDigits: 0,
        minimumFractionDigits: 0,
    });
}
